export const loginStatus = {
  idle: 'idle',
  running: 'running',
  success: 'success',
  error: 'error',
};
